import React from 'react';
import {useTranslation} from 'react-i18next';
import TextAlign from '../../../../../../ui/components/TextAlign';
import BorderRadiusChange from '../../../common/borderRadiusChange';
import AccordionItem from '../../../../../../ui/components/AccordionItem';
import FontAndBackgroundColorPicker, {COLOR_FIELDS} from '../../../common/fontAndBackgroundColorPicker';
import FontSelect from '../../../common/fontSelect';
import {IQuestionElements} from '../../../../../../incase-domain/elements/question';
import DebouncedNumberInput from '../../../common/debounced/DebounceNumberInput';

interface QuestionAdvancedOptionsProps {
    highlightedElement: IQuestionElements;
    highlightedElementChangeHandler: {
        single: (field: keyof IQuestionElements | string, value: unknown) => void;
    };
}

export default function QuestionAdvancedOptions(props: QuestionAdvancedOptionsProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler} = props;
    const {t} = useTranslation();

    return (
        <AccordionItem header={<div className="u-flex u-h-between u-v-center">{t('designSidepanel.question')}</div>}>
            <div className="l-group--form">
                <div className="l-group__item u-flex u-flex-col u-gap-2 u-pb-2">
                    <DebouncedNumberInput
                        label={t('designSidepanel.fontSize')}
                        value={highlightedElement.questionFontSize || 1}
                        onChange={(newValue: number) => highlightedElementChangeHandler.single('questionFontSize', newValue)}
                        step={0.1}
                        min={0.1}
                    />
                    <FontSelect highlightedElement={highlightedElement} highlightedElementChangeHandler={highlightedElementChangeHandler} />
                    <TextAlign
                        alignment={highlightedElement.questionTextAlign}
                        onClick={(alignment) => {
                            highlightedElementChangeHandler.single('questionTextAlign', alignment);
                        }}
                    />
                    <FontAndBackgroundColorPicker
                        highlightedElement={highlightedElement}
                        highlightedElementChangeHandler={highlightedElementChangeHandler}
                        colorFields={[COLOR_FIELDS.QUESTION_BACKGROUND_COLOR]}
                    />
                    <div className="u-mt-1">
                        <BorderRadiusChange
                            borderRadius={highlightedElement.questionBackgroundBorderRadius}
                            highlightedElementChangeHandler={(value) =>
                                highlightedElementChangeHandler.single('questionBackgroundBorderRadius', value)
                            }
                        />
                    </div>
                </div>
            </div>
        </AccordionItem>
    );
}
